import { scaleVariant } from 'src/theme/animations/swipeIn'
import { ContentButton, ContentButtonGrow, ContentNavigation } from './styles'
import { Content, ContentTypographyNavigation, MenuButtonDes } from '../styles'
import FormControl from '@mui/material/FormControl'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import React from 'react'
import { useDropdownInteraction } from 'src/hook'
import { useTranslations } from 'src/provider/LocaleProvider'
import { HeaderLabels } from 'src/constants'

export function NavigationComponent() {
    const t = useTranslations()
    const { GrowOptions, navigateOptions } = HeaderLabels()
    const { handleClick, handleClose, dropdownElement, open } =
        useDropdownInteraction()
    return (
        <ContentNavigation
            marginLeft={[0, 0, 0, 'navigation']}
            initial="initial"
            animate="animate"
            variants={scaleVariant}
        >
            <ContentButtonGrow>
                <FormControl>
                    <MenuButtonDes
                        id="basic-button"
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClick}
                    >
                        <ContentTypographyNavigation
                            variant={'h2'}
                            fontSize={'xxsmall'}
                            fontWeight={500}
                        >
                            {t('cta.growProject')}
                        </ContentTypographyNavigation>
                    </MenuButtonDes>
                    <Menu
                        className={'top_navigation'}
                        id="basic-menu"
                        anchorEl={dropdownElement}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        {GrowOptions.map((option) => (
                            <MenuItem
                                key={option.value}
                                value={option.value}
                                className={'center'}
                            >
                                <Content
                                    to={`/${option.navigate}`}
                                    key={`navData-${option.label}`}
                                >
                                    <ContentTypographyNavigation
                                        variant={'h2'}
                                        fontSize={'xxsmall'}
                                        fontWeight={500}
                                    >
                                        {option.label}
                                    </ContentTypographyNavigation>
                                </Content>
                            </MenuItem>
                        ))}
                    </Menu>
                </FormControl>
            </ContentButtonGrow>

            <ContentButton>
                {navigateOptions.map((el) => {
                    return (
                        <Content
                            to={`/${el.navigation}`}
                            key={`navData-${el.label}`}
                        >
                            <ContentTypographyNavigation
                                variant={'h2'}
                                fontSize={'xxsmall'}
                                fontWeight={500}
                            >
                                {el.label}
                            </ContentTypographyNavigation>
                        </Content>
                    )
                })}
            </ContentButton>
        </ContentNavigation>
    )
}
